import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type {
  ShippingPaperSlice,
  ShippingPapersFilters,
} from "./shippingPapersTypes.ts";

const initialState: ShippingPaperSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const shippingPapersSlice = createSlice({
  name: "shippingPapers",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<ShippingPaperSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<ShippingPaperSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [
          filterType: keyof ShippingPapersFilters,
          filterValue: string | undefined,
        ]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<ShippingPaperSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  shippingPapersSlice.actions;

export const selectPage = (state: RootState) => state.shippingPapers.page;
export const selectRowsPerPage = (state: RootState) =>
  state.shippingPapers.rowsPerPage;
export const selectFilter = (state: RootState) => state.shippingPapers.filter;
export const selectSort = (state: RootState) => state.shippingPapers.sort;

export default shippingPapersSlice.reducer;
